import { Routes } from '@angular/router';
import { Home } from './routes/home/home.component';
import { About } from './routes/about/about.component';
import { Services } from './routes/services/services.component';
import { Projects } from './routes/projects/projects.component';
import { routes as contactRoutes } from './routes/contact/contact.routes';
import { NotFound } from './routes/not-found/not-found.component';
import { ActionConfig } from './app.component';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    component: Home,
    title: 'Home - Hill Tech Works',
    data: {
      description: 'Hill Tech Works builds custom web applications, business websites, and integrations for growing businesses. Practical software built to scale.',
      action: {
        heading: 'Wondering what we can build?',
        body: 'Browse our services to see what we offer.',
        buttonText: 'View services',
        link: '/services',
      } satisfies ActionConfig,
    }
  },
  // {
  //   path: 'about',
  //   component: About,
  //   title: 'About - Hill Tech Works'
  // },
  {
    path: 'services',
    component: Services,
    title: 'Services - Hill Tech Works',
    data: {
      description: 'Explore Hill Tech Works\' services — business websites, custom web applications, and integrations built to solve real problems for growing businesses.',
      breadcrumbs: [
        { name: 'Home', item: 'https://hilltechworks.com' },
        { name: 'Services', item: 'https://hilltechworks.com/services' },
      ],
      action: {
        heading: 'Curious what we\'ve built?',
        body: 'Take a look at some of the projects we\'ve delivered for our clients.',
        buttonText: 'See our work',
        link: '/projects',
      } satisfies ActionConfig,
    }
  },
  {
    path: 'projects',
    component: Projects,
    title: 'Projects - Hill Tech Works',
    data: {
      description: 'See how Hill Tech Works has helped clients with custom websites and software solutions.',
      breadcrumbs: [
        { name: 'Home', item: 'https://hilltechworks.com' },
        { name: 'Projects', item: 'https://hilltechworks.com/projects' },
      ],
      action: {
        heading: 'Ready to get started?',
        body: 'Tell us about your project. We\'ll get back to you within one business day.',
        buttonText: 'Get started',
        link: '/contact',
      } satisfies ActionConfig,
    }
  },
  {
    path: 'contact',
    children: contactRoutes
  },
  {
    path: '**',
    component: NotFound,
    title: 'Not Found - Hill Tech Works'
  }
];
